<div [chart]="temperatureChart"></div>
